import React from 'react';
import PropTypes from 'prop-types';

import {OETargetMenu} from '../../../elements/target-menu/oe-target-menu';
import {OEMainMenuButtonsPropType} from '../../main-menu/oe-main-menu-model';
import {OEStdCapBarPropTypes} from './oe-std-cap-bar-model';
import OEStdMainMenuCapBar from './oe-std-main-menu-cap-bar';
import OEStdTargetBarCapBar from './oe-std-target-bar-cap-bar';

export default function OEStdCapBarSelector(props)  {
    const hasMainMenuButtons = (props.leftMainMenuButtons && props.leftMainMenuButtons.length) || (props.rightMainMenuButtons && props.rightMainMenuButtons.length);

    return hasMainMenuButtons ? <OEStdMainMenuCapBar {...props}/> : <OEStdTargetBarCapBar {...props}/>;
}

OEStdCapBarSelector.defaultProps = {
    className:                      '',
    moduleId:                       '',
    disabled:                       false,
    showMainMenuControlBtn:         true,
    showFullscreenBtn:              true,
    isFullscreen:                   false,
    targetTypeBar:                  [],
    targetMenuDisabled:             false,
    targetMenuHidden:               false
};

OEStdCapBarSelector.propTypes = {
    className:                      PropTypes.string,
    moduleId:                       PropTypes.string,
    disabled:                       PropTypes.bool,
    showMainMenuControlBtn:         PropTypes.bool,
    showFullscreenBtn:              PropTypes.bool,
    isFullscreen:                   PropTypes.bool,
    appComponent:                   PropTypes.object,
    targetTypeBar:                  PropTypes.arrayOf(OEStdCapBarPropTypes.targetTypeButton),
    targetBarTitle:                 PropTypes.string,
    targetBarLabel:                 PropTypes.string,
    targetBarButton:                OEStdCapBarPropTypes.targetBarButton,
    targetMenuEntries:              OETargetMenu.propTypes.entries,
    targetMenuDisabled:             PropTypes.bool,
    targetMenuHidden:               PropTypes.bool,
    onTargetMenuDisabledToggle:     PropTypes.func,
    leftMainMenuButtons:            OEMainMenuButtonsPropType,
    rightMainMenuButtons:           OEMainMenuButtonsPropType,
};